/**
 * Türkçe karakterleri doğru şekilde büyük harfe çevirir
 * @param str - Dönüştürülecek string
 * @returns Büyük harfe çevrilmiş string
 */
export const toTurkishUpperCase = (str: string): string => {
  // Türkçe karakterleri önce büyük harflerine çevir
  const turkishMap: { [key: string]: string } = {
    ı: 'I',
    i: 'İ',
    ğ: 'Ğ',
    ü: 'Ü',
    ş: 'Ş',
    ö: 'Ö',
    ç: 'Ç',
  };

  let result = '';
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (turkishMap[char]) {
      result += turkishMap[char];
    } else {
      result += char.toUpperCase();
    }
  }

  return result;
};

